import { createToggleButtonTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Togglebutton Component Configuration
 * Design tokens sourced from Figma design system
 */
export function createTogglebutton(s: SemanticTokens) {
  const toggleButtonTokens = createToggleButtonTokens(s);
  return {
  root: {
    padding: toggleButtonTokens.base.padding,       
    borderRadius: toggleButtonTokens.base.radius,     
    gap: toggleButtonTokens.base.gap,                
    fontWeight: toggleButtonTokens.base.fontWeight,
    disabledBackground: toggleButtonTokens.bgDisabled, 
    disabledBorderColor: 'transparent',
    disabledColor: toggleButtonTokens.fgDisabled,             
    invalidBorderColor: toggleButtonTokens.borderInvalid,
    checkedBackground: toggleButtonTokens.bgChecked,  
    hoverBackground: toggleButtonTokens.bgHover,
    borderColor: 'transparent',
    color: toggleButtonTokens.fg,                
    hoverColor: toggleButtonTokens.fgHover,             
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none',
    },
  },
  icon: {
    disabledColor: toggleButtonTokens.iconFgDisabled,            
  },
  colorScheme: {
    light: {
      root: {
        background: toggleButtonTokens.bg,
        checkedBackground: toggleButtonTokens.bgChecked,
        hoverBackground: toggleButtonTokens.bgHover, 
        borderColor: 'transparent',
        color: toggleButtonTokens.fg,              
        hoverColor: toggleButtonTokens.fgHover,             
        checkedColor: toggleButtonTokens.fgChecked,          
        checkedBorderColor: 'transparent',
      },
      icon: {
        color: toggleButtonTokens.iconFg,               
        hoverColor: toggleButtonTokens.iconFgHover,
        checkedColor: toggleButtonTokens.iconFgChecked,           
      },
    },
    dark: {
      root: {
        background: toggleButtonTokens.bg,
        checkedBackground: toggleButtonTokens.bgChecked,    
        hoverBackground: toggleButtonTokens.bgHover,           
        borderColor: 'transparent',
        color: toggleButtonTokens.fg,                  
        hoverColor: toggleButtonTokens.fgHover,
        checkedColor: toggleButtonTokens.fgChecked,
        checkedBorderColor: 'transparent',
      },
      icon: {
        color: toggleButtonTokens.iconFg,                  
        hoverColor: toggleButtonTokens.iconFgHover,
        checkedColor: toggleButtonTokens.iconFgChecked,       
      },
    },
  },
  css: (_: unknown) => `
    /* Action variant - icon-only toggle button (similar to p-button-action) */
    .p-togglebutton-action {
      width: ${toggleButtonTokens.base.size};
      height: ${toggleButtonTokens.base.size};
      align-items: center;
    }

    .p-togglebutton-action .p-togglebutton-content {
      flex: none;
      gap: 0;
      width: ${toggleButtonTokens.content.size};
      height: ${toggleButtonTokens.content.size};
    }

    .p-togglebutton-action .p-togglebutton-label {
      display: none;
    }

    .p-togglebutton-action .p-togglebutton-icon {
      font-size: ${toggleButtonTokens.icon.size};
      width: ${toggleButtonTokens.icon.size};
      height: ${toggleButtonTokens.icon.size};
    }
  `,
  };
}
export const togglebutton = createTogglebutton(SEMANTIC);